/***
 * Created on 2023/7/24
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import UserApplication from "./user_app/user_application";
import {useTranslation} from "react-i18next";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import ChangePassword from "./change_password/change_password";
import LoginDevice from "./login_device/login_device";
import DeleteAccount from "./delete_account/delete_account";
import TwoStep from "./two_step/two_step";
import {useLanguage} from 'common/Hook';
import {getLocalUser} from "../../service/user";
import attention_svg from "../../static/img/utils/ic-sys-attention.svg";
import {getCookie} from "../../service/common";


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});


function Security(props) {
    const TABS = {
        user_app: <UserApplication />,
        change_passwd: <ChangePassword />,
        login_device: <LoginDevice />,
        delete_account: <DeleteAccount />,
        two_step: <TwoStep />
    };
    const [tab, setTab] = useState(()=>{
        const url = new URL(window.location);
        const hash = url?.hash ? url.hash.replace('#', '') : "two_step";
        return Object.keys(TABS).includes(hash) ? hash : 'two_step'
    });
    const { t, i18n } = useTranslation();
    const current_user = getLocalUser();
    const is_mobile_app = getCookie("mobile_app") === 'true';
    useLanguage();

    const showTab = (tab) => {
        if (location.hash) {
            const clean_url = location.href.split('#')[0];
            history.replaceState(null, null, clean_url);
        }
        const comp = TABS[tab];
        if (!comp) return <TwoStep />;
        else return comp;
    }

    return (
        <QueryClientProvider client={queryClient}>
            <div className="page-wrapper">
                <header className="page-header">{t('@Security@')}</header>
                <nav className="page-tabbar">
                    <div className="comp-tabbar">
                        <div className="tabbar">
                            <ul>
                                <li className={`tabbar__item cursor-pointer ${tab === 'change_passwd' ? 'active' : ''}`} onClick={()=>setTab('change_passwd')}>{t('@Change Password@')}</li>
                                {!is_mobile_app &&
                                    <>
                                        <li className={`tabbar__item cursor-pointer ${tab === 'two_step' ? 'active' : ''} ${!current_user?.secure?.two_step_enabled ? 'has-attention' : ''}`} onClick={()=>setTab('two_step')}>
                                            {t('@2-Step Verification@')}
                                            {
                                                !current_user?.secure?.two_step_enabled &&
                                                <span className="tabbar__item__ic-attention">
                                                    <img src={attention_svg} alt=""/>
                                                </span>
                                            }
                                        </li>
                                        <li className={`tabbar__item cursor-pointer ${tab === 'login_device' ? 'active' : ''}`} onClick={()=>setTab('login_device')}>{t('@Logged in devices@')}</li>
                                        <li className={`tabbar__item cursor-pointer ${tab === 'user_app' ? 'active' : ''}`} onClick={()=>setTab('user_app')}>{t('@Applications@')}</li>
                                        <li className={`tabbar__item cursor-pointer ${tab === 'delete_account' ? 'active' : ''}`} onClick={()=>setTab('delete_account')}>{t('@Delete My Account@')}</li>
                                    </>
                                }
                            </ul>
                        </div>
                    </div>
                </nav>

                {showTab(tab)}

            </div>
        </QueryClientProvider>
    );
}

export default Security;